<!--Changing Aeon Stones-->
<div class="newrow" *ngFor="let index of get_Slots(); trackBy:trackByIndex;">
    <strong *ngIf="index === 0">Aeon Stones</strong>
    <span *ngIf="index !== 0">&nbsp;</span>
    <select [(ngModel)]="newAeonStone[index]" (change)="add_AeonStone(index)"
        [disabled]="!item.aeonStones[index-1] && index > 0">
        <ng-container
            *ngFor="let stone of get_InitialAeonStones(index); let initialStoneIndex = index; trackBy:trackByIndex;">
            <option [ngValue]="stone" *ngIf="initialStoneIndex === 0">

            </option>
            <optgroup *ngIf="initialStoneIndex === 1" label="Current stone">
                <option [ngValue]="stone">
                    {{stone.aeonStone.name}}
                </option>
            </optgroup>
        </ng-container>
        <ng-container *ngFor="let inv of get_Inventories(); trackBy:trackByIndex;">
            <optgroup label="{{itemStore ? 'Available stones' : inv.get_Name(characterService)}}"
                *ngIf="get_AeonStones(inv).length">
                <option *ngFor="let stone of get_AeonStones(inv); trackBy:trackByIndex;" [ngValue]="stone"
                    title="{{get_Title(stone.aeonStone)}}">
                    {{stone.aeonStone.amount > 1 ? stone.aeonStone.amount+" " :
                    ""}}{{stone.aeonStone.name}}{{get_AeonStoneCooldown(stone.aeonStone)}}
                </option>
            </optgroup>
        </ng-container>
    </select>
</div>
